import Repository from "./repository"

export default {
    /**
     * アカウント一覧取得処理
     * @returns response
     */
    view() {
        return Repository.get("/api/s212-account-management/view")
    },

    /**
     * アカウント削除処理
     * @param   id       削除するID
     * @returns response
     */
    delete(id) {
        return Repository.post("/api/s212-account-management/delete", {id})
    },

    /**
     * アカウント追加処理
     * @param   params   アカウント追加情報
     * @returns response
     */
    add(params) {
        return Repository.post("/api/s212-account-management/add", params)
    },

    /**
     * アカウント追加チェック処理
     * @param   params   アカウント追加のトークン
     * @returns Response
     */
    check(params) {
        return Repository.get("/api/s212-account-management/check", {params})
    },

    /**
     * アカウント追加実行処理
     * @param   params   アカウント追加のトークン
     * @returns Response
     */
    create(params) {
        return Repository.post("/api/s212-account-management/create", params)
    },

    /**
     * アカウント追加申込メール再送信処理
     * @param   id     再送信するアカウント追加のID
     * @returns params
     */
    resend(id) {
        return Repository.post("/api/s212-account-management/resend", {id})
    },

    /**
     * アカウント追加申込削除処理
     * @param   id     削除するアカウント追加のID
     * @returns params
     */
    cancel(id) {
        return Repository.post("/api/s212-account-management/cancel", {id})
    },
}